document.addEventListener('click', function (event) {
  var arrow = event.target.closest('[data-bb-scroll]');
  if (arrow) {
    var rail = arrow.closest('.bb-shelf').querySelector('.bb-shelf__products');
    var card = rail.querySelector('.bb-shelf__product');
    if (card) rail.scrollBy({ left: (card.getBoundingClientRect().width + 14) * (arrow.dataset.bbScroll === 'next' ? 1 : -1), behavior: 'smooth' });
    return;
  }

  var swatch = event.target.closest('.bb-merch-card__swatch');
  if (!swatch) return;
  var card = swatch.closest('[data-bb-product-card]');
  card.querySelectorAll('.bb-merch-card__swatch').forEach(function (button) {
    var selected = button === swatch;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });
  var image = card.querySelector('.bb-merch-card__image');
  if (image && swatch.dataset.bbImageUrl) {
    image.srcset = '';
    image.src = swatch.dataset.bbImageUrl;
  }
  card.querySelectorAll('.bb-merch-card__image-link, .bb-merch-card__name').forEach(function (link) {
    link.href = swatch.dataset.bbVariantUrl;
  });
  var price = card.querySelector('[data-bb-current-price]');
  var compare = card.querySelector('[data-bb-compare-price]');
  var discount = card.querySelector('[data-bb-discount]:not(button)');
  price.textContent = swatch.dataset.bbPrice;
  compare.textContent = swatch.dataset.bbCompare || '';
  compare.hidden = !swatch.dataset.bbCompare;
  discount.textContent = 'Save ' + swatch.dataset.bbDiscount + '%';
  var colorName = card.querySelector('[data-bb-color-name]');
  if (colorName && swatch.dataset.bbColor) colorName.textContent = swatch.dataset.bbColor;
  discount.hidden = Number(swatch.dataset.bbDiscount) <= 0;
});
